import { defineStyleConfig } from '@chakra-ui/react'

export const AtolEligible = defineStyleConfig({
  baseStyle: {
    borderRadius: 'base',
    bgColor: 'brand.teal10',
    color: 'brand.black',
  },
})
